import { type ReactElement, useState } from "react";
import { useCurrentAccount } from "src/hooks";

import { FonciaConsentForm } from ".";
import { type ConsentFormProps } from "../consent-form.types";

type Props = Pick<ConsentFormProps, "isOpen">;

export function FonciaConsentController({ isOpen }: Props): ReactElement {
  const { customer } = useCurrentAccount();
  const [dismissedCustomerId, setDismissedCustomerId] = useState<string>();
  const hasLocalPreview =
    import.meta.env.DEV &&
    new URLSearchParams(window.location.search).get("previewConsent") ===
      "true";
  const shouldRequestConsent = isOpen || hasLocalPreview;

  return (
    <FonciaConsentForm
      key={customer.id}
      open={shouldRequestConsent && dismissedCustomerId !== customer.id}
      firstName={customer.firstName ?? ""}
      onComplete={() => {
        // TODO(ML-27245): persist the selected purposes and channels when the OneTrust contract is available.
        setDismissedCustomerId(customer.id);
      }}
    />
  );
}
